<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="5">
            <!-- Diálogo -->
            <v-dialog
              v-model="dialogo"
              max-width="500"
              persistent
              transition="dialog-bottom-transition"
            >
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card class="rounded-xl elevation-8">
                  <!-- Cabeçalho -->
                  <v-card-title class="justify-center py-6">
                    <v-icon color="primary" size="36" class="mr-2">mdi-lock-reset</v-icon>
                    <span class="text-h6 font-weight-bold text-center">
                      Alterar Senha
                    </span>
                  </v-card-title>

                  <v-divider></v-divider>

                  <v-card-text class="py-6">
                    <!-- Usuário -->
                    <v-sheet
                      class="d-flex align-center pa-3 mb-6 rounded-lg"
                      color="blue lighten-5"
                      elevation="1"
                    >
                      <v-icon color="primary" class="mr-3">mdi-account</v-icon>
                      <div>
                        <span class="text-caption grey--text">Usuário</span>
                        <div class="text-subtitle-1 font-weight-medium primary--text">
                          {{ usuario && usuario.length ? usuario[0].username : '' }}
                        </div>
                      </div>
                    </v-sheet>

                    <!-- Senha atual -->
                    <v-text-field
                      dense
                      outlined
                      clearable
                      class="mb-4"
                      :rules="[rules.required]"
                      prepend-inner-icon="mdi-lock-outline"
                      :type="showSenhaAtual ? 'text' : 'password'"
                      v-model="senha_actual"
                      label="Senha atual"
                      :append-icon="showSenhaAtual ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="showSenhaAtual = !showSenhaAtual"
                    ></v-text-field>

                    <v-alert
                      v-if="show_senha_errada"
                      type="error"
                      dense
                      class="mb-3"
                    >
                      Senha incorreta
                    </v-alert>

                    <v-alert
                      v-if="error_senha_antiga_actual"
                      type="warning"
                      dense
                      class="mb-3"
                    >
                      A senha antiga não pode coincidir com a nova
                    </v-alert>

                    <!-- Nova senha -->
                    <v-text-field
                      dense
                      outlined
                      class="mb-4"
                      prepend-inner-icon="mdi-key-variant"
                      :rules="[rules.required, rules.password_, rules.password]"
                      v-model="senha_nova"
                      :type="showSenhaNova ? 'text' : 'password'"
                      label="Nova senha"
                      :append-icon="showSenhaNova ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="showSenhaNova = !showSenhaNova"
                    ></v-text-field>

                    <!-- Confirmar senha -->
                    <v-text-field
                      dense
                      outlined
                      class="mb-4"
                      prepend-inner-icon="mdi-check-circle-outline"
                      v-model="senha_confirmar"
                      :rules="[rules.required, confirmPasswordRule]"
                      :type="showConfirmar ? 'text' : 'password'"
                      label="Confirmar senha"
                      :append-icon="showConfirmar ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="showConfirmar = !showConfirmar"
                    ></v-text-field>

                    <v-alert
                      v-if="error_confirmar"
                      type="error"
                      dense
                      class="mb-3"
                    >
                      As senhas não correspondem
                    </v-alert>

                    <!-- Feedback -->
                    <div class="d-flex justify-center mt-4">
                      <v-progress-circular
                        v-if="progresso"
                        indeterminate
                        color="primary"
                        size="32"
                      ></v-progress-circular>
                    </div>

                    <v-alert
                      v-if="show_mensagem"
                      type="success"
                      border="left"
                      colored-border
                      elevation="1"
                      class="mt-4 text-center"
                    >
                      Senha alterada com sucesso!
                      <v-btn small text color="blue" to="/">Sair</v-btn>
                    </v-alert>
                  </v-card-text>

                  <v-divider></v-divider>

                  <!-- Ações -->
                  <v-card-actions class="justify-end py-4 px-6">
                    <v-btn
                      color="grey darken-1"
                      text
                      @click="$router.push('/')"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="primary"
                      depressed
                      rounded
                      class="px-6"
                      :disabled="!valid"
                      @click="ContinuarMudarSenha()"
                    >
                      Confirmar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')

export default {
  directives: { mask },
  data: () => ({
    usuario: [],
    dialogo: false,
    senha_actual: '',
    senha_nova: '',
    senha_confirmar: '',
    showSenhaAtual: false,
    showSenhaNova: false,
    showConfirmar: false,
    show_senha_errada: false,
    error_senha_antiga_actual: false,
    error_confirmar: false,
    progresso: false,
    show_mensagem: false,
    valid: true,
    usuario_encontrado: [],
    rules: {
      required: value => !!value || 'Campo obrigatório.',
      password_: value => value.length >= 8 || 'A senha deve ter no mínimo 8 caracteres',
      password: value => {
        var pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/
        return pattern.test(value) || 'A senha deve ter maiúscula, minúscula e número.'
      }
    }
  }),
  created () {
    this.ObterUsuario()
    this.dialogo = true
  },
  methods: {
    confirmPasswordRule (value) {
      return value === this.senha_nova || 'As senhas não correspondem'
    },
    async ObterUsuario () {
      try {
        this.usuario = await axios.get('/PerfilUsuario-dados').then(res => res.data)
      
      } catch (error) {}
    },
    async ContinuarMudarSenha () {
      const dados_1 = { password: this.senha_actual }
      try {
        this.usuario_encontrado = await axios.post('/Verifica-senha-new/', dados_1).then(res => res.data)
      } catch (error) {
        console.log(error)
      }

      if (this.usuario_encontrado.length) {
        this.show_senha_errada = false
               
        if (this.senha_actual !== this.senha_nova) {
          this.error_senha_antiga_actual = false
          if (this.senha_nova === this.senha_confirmar) {
            this.progresso = true
            this.error_confirmar = false
            try {

              await axios.post('/altera-senha/', { password: this.senha_nova, username: this.usuario[0].username })
              this.progresso = false
              this.show_mensagem = true
              this.Limpar()
            } catch (error) {
              this.progresso = false
            }
          } else {
            this.error_confirmar = true
          }
        } else {
          this.error_senha_antiga_actual = true
        }
      } else {
        this.show_senha_errada = true
      }
    },
    Limpar () {
      this.senha_nova = ''
      this.senha_actual = ''
      this.senha_confirmar = ''
      setTimeout(() => {
        this.$router.push('/')
      }, 1000);
    }
  }
}
</script>
